import { useMemo } from 'react';
import EmptyCell from 'components/new-ui/base/emtpy-cell/EmptyCell';
import { CdsDeclaration } from 'store/declarations/uk/cds-declaration';
import { getDeclarationPayload, getImporter } from 'views/declarations/utils/declaration-utils';
import { Declaration } from 'store/declarations/declaration';

type Props = {
    declaration?: Declaration;
    dataTestId?: string;
};

const Consignee = ({ declaration, dataTestId }: Props) => {
    let payload = useMemo(() => getDeclarationPayload(declaration), [declaration]);

    if (!payload || !declaration) return <EmptyCell dataTestId={dataTestId} />;

    payload = (payload as CdsDeclaration)?.cdsDeclarationPayload ?? payload;
    const importer = getImporter(payload as any);

    if (!importer?.name) {
        return <EmptyCell dataTestId={dataTestId} />;
    }

    return <span data-testid={dataTestId}>{importer.name}</span>;
};

export default Consignee;
